import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import CheckInDateRangeFactory from '@/js/common/Domain/Factory/checkInDateRange/CheckInDateRange';
import MealsRepository from '@/js/common/Domain//Repository/Meals';
import DataProxy from '@/js/common/Domain/Service/DataProxy';

import RailwayTour from '../objectValue/RailwayTour';

export default function RailwayTourFactory(data) {
    const railwayTour = {};
    let element;
    let dateParts;

    element = data.tourCriteria;
    if (typeof element !== 'undefined') {
        railwayTour.tourCriteria = element;
    }

    element = data.id;
    if (typeof element !== 'undefined') {
        railwayTour.id = element;
    }

    element = data.sortRate;
    if (typeof element !== 'undefined') {
        railwayTour.sortRate = element;
    }

    element = data.nights;
    if (typeof element !== 'undefined') {
        railwayTour.nights = element.tour;
        railwayTour.nightsInHotel = element.hotel;
    }

    element = data.checkInDate;
    if (typeof element !== 'undefined' && railwayTour.nights) {
        railwayTour.checkInDate = element;
        railwayTour.checkInDateRange = new DataProxy(() => {
            element = data.checkInDate;

            dateParts = element.split('-');

            return CheckInDateRangeFactory({
                from: element,
                to: new Date((new Date(dateParts[0], dateParts[1] - 1, dateParts[2])).getTime() + railwayTour.nightsInHotel * 3600 * 24 * 1000 + 3600 * 4 * 1000),
            });
        });
    }

    element = data.touristGroup;
    if (typeof element !== 'undefined') {
        railwayTour.touristGroup = element;
    }

    element = data.operator;
    if (typeof element !== 'undefined') {
        railwayTour.operator = OperatorsRepository.repository.add(element).toJSON() || null;
    }

    element = data.meal;
    if (typeof element !== 'undefined') {
        railwayTour.meal = MealsRepository.repository.get(element) || element;
    }

    element = data.price;
    if (typeof element !== 'undefined') {
        railwayTour.price = element;
    }

    element = data.discount;
    if (typeof element !== 'undefined') {
        railwayTour.discount = element;
    }

    element = data.medicalInsurance;
    if (typeof element !== 'undefined') {
        railwayTour.medicalInsurance = element;
    }

    element = data.hotel;
    if (typeof element !== 'undefined') {
        railwayTour.hotel = element;
    }

    element = data.cashbackAvailable;
    if (typeof element !== 'undefined') {
        railwayTour.cashbackAvailable = element;
    }

    element = data.firstPaymentDefinition;
    if (typeof element !== 'undefined') {
        railwayTour.firstPaymentDefinition = element;
    }

    element = data.room;
    if (typeof element !== 'undefined') {
        railwayTour.room = element;
    }

    element = data.maxHistoricalPrice;
    if (typeof element !== 'undefined') {
        railwayTour.maxHistoricalPrice = element;
    }

    element = data.hotelAvailable;
    if (typeof element !== 'undefined') {
        railwayTour.hotelAvailable = element;
    }

    if (data.maxHistoricalPrice && data.price) {
        const { maxHistoricalPrice, price } = data;
        railwayTour.originalPrice = maxHistoricalPrice;
        railwayTour.discount = price < maxHistoricalPrice ? (1 - price / maxHistoricalPrice) : 0;
    }

    element = data.routes;
    if (typeof element !== 'undefined') {
        railwayTour.routes = element;
    }

    railwayTour.roomGroups = data?.roomGroups?.length ? data.roomGroups : [{ touristGroup: data.touristGroup, room: '', hash: '' }];

    return new RailwayTour(railwayTour);
}